<div id="imageoneTraining" *ngIf="imageoneTraining">
	<imageone-training [pageDisplay]="pageDisplay" [pageTitle]="pageTitle"></imageone-training>
</div>